const CARACTERES_MAX_DOMICILIO = 50
const CARACTERES_MAX_CP = 10
const TIPO_USUARIO_DOMICILIO = {
  CLIENTE: 'A',
  PROVEEDOR: 'P',
  PARTICULAR: 'R'
}

export const puedeAgregarDomicilio = (tipoUsuario) => {
  return tipoUsuario !== TIPO_USUARIO_DOMICILIO.CLIENTE
}

export const puedeEditarDomicilio = (tipoUsuario, domicilio, esPerfil = false) => {
  if (!domicilio?.vieneDeEBM) return false
  if (esPerfil) return false
  return tipoUsuario !== TIPO_USUARIO_DOMICILIO.CLIENTE
}

export const puedeEliminarDomicilio = (tipoUsuario, domicilio) => {
  if (!puedeEditarDomicilio(tipoUsuario, domicilio)) return false
  return !domicilio?.domicilioPrincipal && !domicilio?.domicilioFacturacion
}

export const construirCamposFormularioDomicilio = ({
  provincias = [],
  localidades = [],
  domicilio = {},
  incluirCamposExtras = false,
  editable = true,
  tipoUsuario = ''
} = {}) => {
  const puedeEditar = editable ?? puedeEditarDomicilio(tipoUsuario, domicilio)
  const camposBase = { isFullWidth: false, isEditable: puedeEditar, isGrid: false }
  return [
    {
      type: 'text',
      name: 'tipoDomicilio',
      label: 'Nombre Domicilio',
      isFullWidth: true,
      isEditable: puedeEditar,
      isGrid: false
    },
    !puedeEditar && {
      ...camposBase,
      type: 'checkbox',
      name: 'domicilioPrincipal',
      label: 'Es domicilio principal'
    },
    !puedeEditar && {
      ...camposBase,
      type: 'checkbox',
      name: 'domicilioFacturacion',
      label: 'Es domicilio de facturación'
    },
    {
      ...camposBase,
      type: 'text',
      name: 'calle',
      label: 'Calle'
    },
    {
      ...camposBase,
      type: 'text',
      name: 'calleAltura',
      label: 'Altura'
    },
    {
      ...camposBase,
      type: incluirCamposExtras ? 'select' : 'text',
      name: 'provincia',
      label: 'Provincia',
      placeholder: 'Seleccionar Provincia',
      options: provincias.map((provincia) => ({
        value: provincia.nombre,
        label: provincia.nombre,
        key: provincia.idProvincia
      }))
    },
    {
      ...camposBase,
      type: incluirCamposExtras ? 'select' : 'text',
      name: 'localidad',
      label: 'Ciudad',
      placeholder: 'Seleccionar Ciudad',
      options: localidades.map((localidad, idx) => ({
        value: localidad,
        label: localidad,
        key: `${localidad}-${idx}`
      }))
    },
    {
      ...camposBase,
      type: 'text',
      name: 'cp',
      label: 'Código Postal'
    },
    incluirCamposExtras && {
      ...camposBase,
      type: 'text',
      name: 'piso',
      label: 'Piso'
    },
    incluirCamposExtras && {
      ...camposBase,
      type: 'text',
      name: 'departamento',
      label: 'Departamento o Casa'
    },
    incluirCamposExtras && {
      type: 'text',
      name: 'anotaciones',
      label: 'Anotaciones para entrega',
      isFullWidth: true,
      isEditable: puedeEditar,
      isGrid: false
    }
  ].filter(Boolean)
}

export const valoresInicialesFormularioDomicilio = {
  tipoDomicilio: '',
  domicilioPrincipal: false,
  domicilioFacturacion: false,
  calle: '',
  calleAltura: '',
  piso: '',
  departamento: '',
  provincia: '',
  localidad: '',
  ciudad: '',
  cp: '',
  anotaciones: '',
  idUsuario: 0,
  vieneDeEBM: false
}

export const validarCamposDomicilio = (values) => {
  const errores = {}
  const { tipoDomicilio, calle, calleAltura, cp, provincia, localidad } = values

  if (!tipoDomicilio || !tipoDomicilio.trim()) {
    errores.tipoDomicilio = 'El nombre del domicilio es obligatorio'
  } else if (tipoDomicilio.trim().length > CARACTERES_MAX_DOMICILIO) {
    errores.tipoDomicilio = `El nombre del domicilio no puede superar los ${CARACTERES_MAX_DOMICILIO} caracteres`
  }

  if (!calle || !calle.trim()) {
    errores.calle = 'La calle es obligatoria'
  } else if (calle.trim().length > CARACTERES_MAX_DOMICILIO) {
    errores.calle = `La calle no puede superar los ${CARACTERES_MAX_DOMICILIO} caracteres`
  }

  if (!calleAltura || !calleAltura.trim()) {
    errores.calleAltura = 'La altura de la calle es obligatoria'
  } else if (calleAltura.trim().length > CARACTERES_MAX_DOMICILIO) {
    errores.calleAltura = `La altura no puede superar los ${CARACTERES_MAX_DOMICILIO} caracteres`
  }

  if (!cp || !cp.trim()) {
    errores.cp = 'El código postal es obligatorio'
  } else if (cp.trim().length > CARACTERES_MAX_CP) {
    errores.cp = `El código postal no puede superar los ${CARACTERES_MAX_CP} caracteres`
  }

  if (!provincia || !provincia.trim()) {
    errores.provincia = 'La provincia es obligatoria'
  }
  if (!localidad || !localidad.trim()) {
    errores.localidad = 'La localidad es obligatoria'
  }

  return errores
}
